var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModalYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFEAD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFF6ED",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 24.5V28.5M27.9998 32.5H28.0098M26.2898 19.36L17.8198 33.5C17.6451 33.8024 17.5527 34.1453 17.5518 34.4945C17.5508 34.8437 17.6413 35.1871 17.8142 35.4905C17.9871 35.7939 18.2365 36.0467 18.5375 36.2238C18.8385 36.4009 19.1806 36.4961 19.5298 36.5H36.4698C36.819 36.4961 37.1611 36.4009 37.4621 36.2238C37.7631 36.0467 38.0124 35.7939 38.1854 35.4905C38.3583 35.1871 38.4488 34.8437 38.4478 34.4945C38.4468 34.1453 38.3544 33.8024 38.1798 33.5L29.7098 19.36C29.5315 19.0661 29.2805 18.8231 28.981 18.6544C28.6814 18.4858 28.3435 18.3972 27.9998 18.3972C27.656 18.3972 27.3181 18.4858 27.0186 18.6544C26.7191 18.8231 26.468 19.0661 26.2898 19.36Z",
    stroke: "#EC4A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModalYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/modalYellow.3b7ab49007e1470656eb95e2382d6835.svg";